import { getQueryStringParameters } from 'owa-querystring';
import { setRedirectInProgress } from './isBootError';
import { OwaWebServerAuthState } from './types/OwaWebServerAuthState';

export default function doAuthRedirectForMini(loc: Location, headers?: Headers) {
    const query = getQueryStringParameters(loc);
    let needsRedirect = false;

    const claimsChallengeQuery = headers ? headers.get('X-OWA-ClaimChallenge') : undefined;
    if (claimsChallengeQuery && query.cc !== claimsChallengeQuery) {
        query.cc = decodeURIComponent(claimsChallengeQuery);
        needsRedirect = true;
    }

    if (query.authRedirect === undefined) {
        query.authRedirect = 'true';
        needsRedirect = true;
    }

    if (needsRedirect) {
        // Set redirection in progress
        setRedirectInProgress(true);

        query.state = OwaWebServerAuthState.Login;
        loc.search = '?' + stringify(query);
    }
}

export function stringify(params: { [key: string]: string }): string {
    if (params) {
        return Object.keys(params)
            .map(
                k => encodeURIComponent(k) + (params[k] ? '=' + encodeURIComponent(params[k]) : '')
            )
            .join('&');
    }
    return '';
}
